<mat-toolbar class="p-0 mat-elevation-z1">
    <div class="toolbar">
        <div class="toolbar-left">
            <div class="navbar-toggle-button hide-xl">
                @if (!hiddenNavbar && !rightNavbar) {
                    <button mat-icon-button (click)="toggleSidebarOpen('navbar')">
                        <mat-icon class="secondary-text">menu</mat-icon>
                    </button>
                }
            </div>

            @if (!hiddenNavbar && !rightNavbar) {
                <div class="toolbar-separator hide-xl"></div>
            }

            <button
                mat-button
                [matMenuTriggerFor]="storeMenu"
                (menuOpened)="contextFilter.focus()"
                class="store-button"
                [ngClass]="{ 'search-mode': searchMode }"
            >
                <div class="selected-context">
                    @switch (viewContext.type) {
                        @case ('none') {
                            <span>None</span>
                        }
                        @case ('store') {
                            <div class="store-info">
                <span class="store-env" [ngClass]="['store-env-' + viewContext.storeEnvironment]"
                >{{ viewContext.storeEnvironment | shortStoreEnv }}
                </span>
                                <span
                                    class="store-display-name"
                                    [ngClass]="{ 'striked-text': viewContext.status !== 'Active' }"
                                >{{ viewContext.storeLabel }}</span
                                >
                                <span
                                    class="store-id"
                                    [ngClass]="{ 'striked-text': viewContext.status !== 'Active' }"
                                >{{ viewContext.storeId }}</span
                                >
                                <span class="subscription-name">{{ viewContext.subscriptionLabel }}</span>
                            </div>
                        }
                        @case ('subscription') {
                            <span>Subscription: {{ viewContext.subscriptionLabel }}</span>
                        }
                        @case ('library') {
                            <span>Library: {{ viewContext.libraryOwner }}</span>
                        }
                        @case ('fulfiller') {
                            <span>Fulfiller: {{ viewContext.fulfillerId }}</span>
                        }
                    }
                    <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #storeMenu="matMenu" [overlapTrigger]="false" class="context-selector-menu">
                <div mat-menu-item disableRipple="true" appInteract (interact)="$event.stopPropagation()" class="store-field">
                    <input
                        #contextFilter
                        type="text"
                        class="filter"
                        [(ngModel)]="contextFilterText"
                        (keyup)="updateFilter()"
                        placeholder="Filter"
                        (keydown)="preventMenuFocus($event)"
                        (keydown.enter)="selectFirstContext($event)"
                    />
                    <button mat-icon-button [matMenuTriggerFor]="filterConfig">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #filterConfig>
                        <button mat-menu-item (click)="toggleFilterShowActiveStores($event)">
                            @if (filter.showActiveStores) {
                                <mat-icon color="accent">check_box</mat-icon>
                            }
                            @if (!filter.showActiveStores) {
                                <mat-icon color="accent">check_box_outline_blank</mat-icon>
                            }
                            Stores - Active
                        </button>
                        <button mat-menu-item (click)="toggleFilterShowDeactivatedStores($event)">
                            @if (filter.showDeactivatedStores) {
                                <mat-icon color="accent">check_box</mat-icon>
                            }
                            @if (!filter.showDeactivatedStores) {
                                <mat-icon color="accent"
                                >check_box_outline_blank
                                </mat-icon
                                >
                            }
                            Stores - Deactivated
                        </button>
                        <button mat-menu-item (click)="toggleFilterShowSubscriptions($event)">
                            @if (filter.showSubscriptions) {
                                <mat-icon color="accent">check_box</mat-icon>
                            }
                            @if (!filter.showSubscriptions) {
                                <mat-icon color="accent"
                                >check_box_outline_blank
                                </mat-icon>
                            }
                            Subscriptions
                        </button>
                        <button mat-menu-item (click)="toggleFilterShowLibraries($event)">
                            @if (filter.showLibraries) {
                                <mat-icon color="accent">check_box</mat-icon>
                            }
                            @if (!filter.showLibraries) {
                                <mat-icon color="accent">check_box_outline_blank</mat-icon>
                            }
                            Libraries
                        </button>
                        <button mat-menu-item (click)="toggleFilterShowFulfillers($event)">
                            @if (filter.showFulfillers) {
                                <mat-icon color="accent">check_box</mat-icon>
                            }
                            @if (!filter.showFulfillers) {
                                <mat-icon color="accent">check_box_outline_blank</mat-icon>
                            }
                            Fulfillers
                        </button>
                    </mat-menu>
                </div>
                @for (contextResult of filteredContexts; track identifyContext($index, contextResult)) {
                    @if (contextResult.obj; as context) {
                        <button
                            mat-menu-item
                            class="context-element"
                            (click)="selectContext(context)"
                            [disabled]="areContextEquals(viewContext, context)"
                        >
                            @switch (context.type) {
                                @case ('none') {
                                    <span>None</span>
                                }
                                @case ('store') {
                                    <div class="store-context">
                          <span class="store-env" [ngClass]="['store-env-' + context.storeEnvironment]">
                            {{ context.storeEnvironment | shortStoreEnv }}
                          </span>
                                        <span class="store-display-name" [ngClass]="{ 'striked-text': context.status !== 'Active' }">
                            <admin-fuzzy-sort-result-highlight [result]="contextResult" [fuzzySearchKeys]="fuzzySearchKeys"
                                                               [key]="'storeLabel'" />
                          </span>
                                        <span class="store-id" [ngClass]="{ 'striked-text': context.status !== 'Active' }">
                            <admin-fuzzy-sort-result-highlight [result]="contextResult" [fuzzySearchKeys]="fuzzySearchKeys"
                                                               [key]="'storeId'" />
                          </span>
                                    </div>
                                }
                                @case ('subscription') {
                                    <span class="subscription-context">
                          <span>
                            Sub:
                            <admin-fuzzy-sort-result-highlight [result]="contextResult" [fuzzySearchKeys]="fuzzySearchKeys"
                                                               [key]="'subscriptionLabel'" />
                          </span>
                          <span class="subscription-id">
                            {{ context.subscriptionId }}
                          </span>
                        </span>
                                }
                                @case ('library') {
                                    <span>
                          Library:
                          <admin-fuzzy-sort-result-highlight [result]="contextResult" [fuzzySearchKeys]="fuzzySearchKeys"
                                                             [key]="'libraryOwner'" />
                        </span>
                                }
                                @case ('fulfiller') {
                                    <span>
                          Fulfiller:
                          <admin-fuzzy-sort-result-highlight [result]="contextResult" [fuzzySearchKeys]="fuzzySearchKeys"
                                                             [key]="'fulfillerId'" />
                        </span>
                                }
                            }
                        </button>
                    }
                }
                @if (someFilteredContextsHidden) {
                    <button
                        mat-menu-item
                        class="filtered-result-indicator"
                        [disabled]="true"
                    >
                        <span>Too many items, please use filter</span>
                    </button>
                }
            </mat-menu>
        </div>

        <div class="toolbar-right">
            <div class="toolbar-separator"></div>
            @let userAccount = userAccount$ | async;
            @if (userAccount) {
                <button
                    mat-button
                    aria-label="Open user menu"
                    [matMenuTriggerFor]="userMenu"
                    class="user-button"
                >
                    <div class="user-info">
                  <span [matBadge]="userAccount.isMfaEnabled ? undefined : 1">
                    @if (userAccount?.picture) {
                        <img alt="" class="avatar" [src]="userAccount.picture" />
                    }
                  </span>
                        <span class="username">{{ userAccount.email }}</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </div>
                </button>
            }

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                <button mat-menu-item class="" (click)="signOut()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Logout</span>
                </button>
                @if (!userAccount?.isMfaEnabled) {
                    <button mat-menu-item (click)="enrollMfa()" [disabled]="enrollingMfa">
                        <mat-icon matBadge="1" matBadgeSize="small" aria-hidden="false">security</mat-icon>
                        <span>Setup Multi-Factor Auth</span>
                    </button>
                }
            </mat-menu>

            <div class="toolbar-separator"></div>

            <fuse-search-bar
                (go)="search($event)"
                (collapsedChanged)="searchCollapsedChanged($event)"
            ></fuse-search-bar>

            <div class="toolbar-separator"></div>

            <div class="quick-panel-toggle-button">
                <button mat-icon-button (click)="toggleSidebarOpen('quickPanel')" aria-label="Toggle quick panel">
                    <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
                </button>
            </div>

            @if (!hiddenNavbar && rightNavbar) {
                <div class="toolbar-separator"></div>
            }

            @if (!hiddenNavbar && rightNavbar) {
                <button
                    mat-icon-button
                    class="navbar-toggle-button"
                    aria-label="Open navigation"
                    (click)="toggleSidebarOpen('navbar')"
                >
                    <mat-icon class="secondary-text">menu</mat-icon>
                </button>
            }
        </div>
    </div>
</mat-toolbar>
